import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const MapSkeleton = styled(Skeleton)`
    width: 100%;
    height: 18.75rem;

    ${purpurMedia('md')`
        height: 40.625rem;
    `};

    ${purpurMedia('xl')`
        width: 50.9rem;
    `};
`;

export const FilterSkeleton = styled(Skeleton)`
    width: 100%;
    height: 2rem;
    margin-bottom: ${getPurpurSpacing('200')};

    ${purpurMedia('xl')`
        height: 10rem;
        margin-bottom: ${getPurpurSpacing('600')};
    `};
`;
